import './styles.scss';

export const MusicDivider = () => <hr className="MusicDivider" />;
